<template>
  <v-layout align-center>
    <v-flex xs12 sm10 md8 lg6>
      <v-layout wrap>
        <v-flex xs12>
          <div v-if="$apollo.loading">
            <spinner />
          </div>
          <form v-else v-scroll-to-error @submit.prevent="submitForm" class="form-container">
            <div class="main-title">
              <span>{{ screenTitle }}</span>
            </div>
            <accreditation-form
              :event="event"
              :initial-values="form"
              :vs="$v"
              :fields="schema.attendeeFields"
              @values="form = $event"
            />
            <div
              v-if="event.flags && event.flags.timeRestrictedAttendeeEntrance"
              style="display: flex; gap: 8px"
            >
              <datetime-field
                v-model="form.entryFrom"
                label="Entry from*"
                style="width: 100%"
                :max="event.to.toString()"
              />
              <datetime-field
                style="width: 100%"
                v-model="form.entryTo"
                label="Entry to*"
                :min="event.from.toString()"
              />
            </div>
            <div class="buttons-container">
              <main-button text="Cancel" flat @click.prevent="goBack" />
              <div class="lower-buttons">
                <main-button
                  v-if="designSet"
                  text="Create & Print"
                  depressed
                  @click="print"
                  outline
                  flat
                />
                <v-tooltip v-else top color="#979797">
                  <main-button slot="activator" text="Create & Print" disabled />
                  <span
                    >Before printing the accreditations, you need to create a template for them in
                    Design Tool.</span
                  >
                </v-tooltip>
                <main-button text="Create" depressed @click="$emit('submit')" />
              </div>
            </div>
          </form>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import AccreditationForm from './accreditation-form.vue'
import { createAttendee } from './../../http'
import { GET_EVENT_CATEGORIES } from '../../graphql/event.graphql'
import MainButton from './../shared/main-button'
import { frontendURL, submitGuard, createAttendeeSchema } from './../../utils'
import Spinner from '../shared/spinner.vue'

import { requiredIf } from 'vuelidate/lib/validators'

export default {
  name: 'create-accreditation',
  components: {
    AccreditationForm,
    MainButton,
    Spinner,
  },
  props: {
    organizationSlug: String,
    eventId: {
      default: null,
      type: String,
    },
    screenTitle: {
      default: 'New Accreditation',
      type: String,
    },
    hiddenCustomField: {
      default: () => {},
      type: Object,
    },
  },
  data: () => ({
    event: {},
    form: {},
  }),
  validations() {
    return {
      form: {
        category: { required: requiredIf(() => this.event.extraModules.categoriesAndZones) },
        zones: { required: requiredIf(() => this.event.extraModules.categoriesAndZones) },
        ...this.schema.validationSchema,
      },
    }
  },
  apollo: {
    getEventCategories: {
      query: GET_EVENT_CATEGORIES,
      variables() {
        return {
          id: this.eventId,
        }
      },
      manual: true,
      result({ data: { getEventCategories: event }, loading }) {
        if (!loading) {
          this.event = event
          this.schema = createAttendeeSchema(this.event.attendeeFields, {})
        }
      },
    },
  },
  computed: {
    designSet() {
      return !!this.event.builder
    },
  },
  methods: {
    async createAttendee(values) {
      const { category: categoryId, zones, ...rest } = values

      return createAttendee(this.eventId, categoryId, zones, null, {
        ...rest,
        ...this.hiddenCustomField,
      })
    },
    async submitForm() {
      await submitGuard(this, async () => {
        await this.createAttendee(this.form)
        this.goBack()
      })
    },
    async print() {
      await submitGuard(this, async () => {
        const { id: attendeeId } = await this.createAttendee(this.form)
        const url = `${frontendURL}/organizations/${this.organizationSlug}/events/${this.event.id}/accreditation/${attendeeId}/edit/print`
        window.open(url, '_blank')
      })
    },
  },
}
</script>

<style>
.main-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 1.5rem;
  line-height: 120%;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.4375rem;
}
.buttons-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
@media screen and (max-width: 480px) {
  .buttons-container {
    flex-direction: column;
  }
  .lower-buttons {
    display: flex;
    flex-direction: column;
  }
}
@media screen and (max-width: 800px) {
  .main-title {
    display: none;
  }
  .form-container {
    margin-top: 1.5rem;
  }
}
</style>
